import React from 'react'
import Link from 'gatsby-link'
import Helmet from 'react-helmet'
import FlexContainer from "../components/flex-container.js";
import SidebarLeft from "../components/sidebar-left.js";
import SidebarRight from "../components/sidebar-right.js";
import Container from '../components/container.js'
import ImageFooter from '../components/image-footer-flaneur.js'
import BtnInstagram from '../components/btn-instagram.js'
import SvgHamburger from "../../images/hamburger.svg"

const LeCoinDuFlaneur = () => (
    <div>
    <FlexContainer>
        <Helmet bodyAttributes={{class: 'hamburger'}}/>
        <SidebarLeft></SidebarLeft>
        <Container>
            <SvgHamburger/>
            <h1>Le coin du flâneur</h1>
            <p>Le web, c'est énorme. Vous vous êtes rendus jusqu'ici. Laissez une trace et, si le coeur vous en dit, laissez-nous des suggestions de lieux, de personnages et de démarches. Nous ne sommes pas des bombes réactives, mais on prend le temps de lire: qui sait ce qui nous arrêtera.</p>

            <a href="mailto:ludovicalefilm@gmail.com">ludovicalefilm@gmail.com</a>
        </Container>
        <SidebarRight>
            <BtnInstagram/>
        </SidebarRight>
    </FlexContainer>
    <ImageFooter/>
    </div>
)

export default LeCoinDuFlaneur



// WEBPACK FOOTER //
// ./src/pages/le-coin-du-flaneur.js